"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    className: "filter_svg__border",
    d: "M9.5 11.395v1.59l-3 1.5v-3.09a4.5 4.5 0 00-.74-2.472L1.436 2.346a.5.5 0 01.418-.775h12.292a.5.5 0 01.418.775L10.24 8.923a4.5 4.5 0 00-.74 2.472z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "filter_svg__filled",
    d: "M12.673 4.818l-9.106.919 2.936 4.577.221 3.756 2.462-1.136.474-3.41 3.013-4.706z",
    fill: "#4D4D4D"
  }));
}

var MemoSvgFilter = /*#__PURE__*/React.memo(SvgFilter);
var _default = MemoSvgFilter;
exports["default"] = _default;